// MODEL : instance of Domain

define('app/dashboard/DashboardMonitorsGridView',['require','glu/itemView','glu/grid','glu/dialog','glu/collection','app/visualizations/FormatFactory','app/visualizations/MonitorNameCell','app/app','hbs!./DashboardMonitorsGridView.hbs'],function(require) {

	'use strict';
	var ItemView = require('glu/itemView'),
		Grid = require('glu/grid'),
		Dialog = require('glu/dialog'),
		Collection = require('glu/collection'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		MonitorNameCell = require('app/visualizations/MonitorNameCell'),
		App = require('app/app');

	var dateFormat = FormatFactory.formatterForType('DATETIME');

	return ItemView.extend({
		template: require('hbs!./DashboardMonitorsGridView.hbs'),
		className: 'monitors-grid-container',

		ui: {
			$menuTrigger: '.grid-manage-column-menu-trigger',
			$searchTxt: '.monitor-search [name=searchTxt]'
		},

		events: {
			'click .dashbrdgrid-monitor-delete': 'deleteHandler',
			'keyup @ui.$searchTxt': 'filter'
		},

		initialize: function() {
			// this will allow to use mock dialog in unit tests
			this.dialog = Dialog;
			this.items = this.options.items;
			this.itemType = this.options.itemType;

			//listening for domain report/segment collections to change
			// and synchronize grid data accordingly
			if (this.items !== undefined) {
				this.listenTo(this.items, 'add', this.addEntity);
				this.listenTo(this.items, 'remove', this.removeEntity);
			}

			this.data = new Collection([]);

			var columns = [{
				field: 'entityViewType',
				label: 'View',
				title: 'Monitor',
				safe: false,
				width: 50
			}, {
				field: 'namelink',
				label: 'Name',
				title: 'The name of the monitor',
				cellView: MonitorNameCell,
				safe: false,
				width: 200
			}, {
				field: 'description',
				label: 'Description',
				title: 'The description',
				width: 200
			}, {
				field: 'dateModified',
				label: 'Date Modified',
				title: 'Date of last modification (New York time zone)',
				width: 200,
				type: 'date',
				format: dateFormat
			}, {
				field: 'domainName',
				label: 'Domain',
				title: 'The domain of the monitor',
				width: 140
			}, {
				field: 'owner',
				label: 'Owner',
				title: 'Owner of the monitor',
				width: 140
			}, {
				field: 'remove',
				label: '',
				title: 'Delete',
				safe: false,
				sortable: false,
				width: 50
			}];

			this.grid = new Grid({
				collection: this.data,
				columns: columns,
				loadingViewText: 'Searching for reports...',
				emptyViewText: 'No monitors found.'
			});
		},

		killEventListeners: function() {
			this.undelegateEvents();
			this.stopListening();
		},

		onRender: function() {
			this.$el.append(this.grid.render().el);
			this.items.each(this.addEntity, this);
		},

		deleteHandler: function(e) {
			//find entity id
			var eid = this.$(e.target).data('eid');
			if (!eid) {
				throw Error('Entity id is not associated with delete button');
			}
			//find if this is a report or segment
			var dataEl = this.data.get(eid);
			if (!dataEl) {
				throw Error('Entity id \'' + eid + '\'is not found in grid data collection');
			}

			//pull entity and associated collection from domain
			var entityCollection = this.items;
			var entity = entityCollection.get(eid);
			if (!entity) {
				throw Error('Entity \'' + eid + '\' does not exist in domain');
			}

			//confirmation dialog
			var msg = 'Are you sure you want to delete this monitor?';
			this.dialog.confirm(msg, 'Delete Monitor', function(ok) {
				if (ok) { // Logic if 'Yes' is clicked
					//this 'delete()' will trigger the DELETE HTTP request
					entity.delete().then(function() {
						entityCollection.remove(entity); //this will remove entity from domain report/segment collections
						App.openReports.remove(entity.getId()); //this will remove entity from navigation
					}, function(data) {
						if (data && data.responseJSON) {
							if (data.responseJSON.errorCode !== 'UNKNOWN_EXCEPTION') {
								Dialog.alert(data.responseJSON.errorMessage, 'An error occurred');
							} else {
								Dialog.alert('An error occurred while processing your request. Please contact your local administrator.', 'An error occurred');
							}
						}
					});
					return;
				}
			});
		},

		addEntity: function(entity) {

			// filter by search box
			if (this.isFiltered(entity)) {
				return;
			}

			//delete button
			var remove = '';
			if (entity.canBeDeleted()) {
				remove += '<div style="position:relative">';
				remove += '<span class="icon-close dashbrdgrid-monitor-delete" title="Delete the monitor" data-eid="' + entity.id + '"></span>';
				remove += '</div>';
			}

			//namelink
			var namelink = {
				name: entity.getName(),
				domainId: entity.getDomainId(),
				id: entity.id,
				toString: function() {
					var name = this.name;
					//for some reason the 'this.name' is undefined in PhantomJS (I have 1.9.8 version)
					// and tests fail here. It might be related to this bug:
					//   https://github.com/ariya/phantomjs/issues/11722
					// so this is a work-around for now
					if (!name) {
						name = 'no-name';
					}
					return name.toLowerCase();
				}
			};

			var domain = App.domains.filter(function(d) {
				return (entity.getDomainId() === d.get('id'));
			});

			var domainName = '';
			if (domain.length > 0) {
				domainName = domain[0].get('name');
			}

			//entity view type
			var entityViewTypeDiv = '<div class="dashbrdgrid-report-visual-style icon-workspace" title="Monitor" />';

			//finally add the model corresponding to the entity
			this.data.push({
				entityViewType: entityViewTypeDiv,
				namelink: namelink,
				description: entity.getDescription(),
				dateModified: entity.getDateModified(),
				domainName: domainName,
				owner: entity.getOwner(),
				remove: remove,
				//additional properties
				id: entity.id
			});
		},

		removeEntity: function(entity) {
			this.data.remove(this.data.get(entity.id));
		},

		isFiltered: function(entity) {
			var searchTxt = this.ui.$searchTxt.val();

			// name
			var name = entity.getName();
			var idxName = -1;
			if (name) {
				idxName = name.toLowerCase().indexOf(searchTxt.toLowerCase());
			}

			// description
			var description = entity.getDescription();
			var idxDesc = -1;
			if (description) {
				idxDesc = description.toLowerCase().indexOf(searchTxt.toLowerCase());
			}

			// owner
			var owner = entity.getOwner();
			var idxOwner = -1;
			if (owner) {
				idxOwner = owner.toLowerCase().indexOf(searchTxt.toLowerCase());
			}

			if (idxName > -1 || idxDesc > -1 || idxOwner > -1) {
				return false;
			}
			return true;
		},

		filter: function() {
			// clear data
			while (this.data.length) {
				this.data.pop();
			}
			// reload data
			this.items.each(this.addEntity, this);
		}
	});
});

